const mEditionMapActivationSendingOfDeliverablesDropDownFilters = {
  mEditionMapActivationSendingOfDeliverablesDropDownFilters: {
    buttons: {
      reload: 'ACTUALIZAR',
      search: 'FILTRAR'
    },

    inputs: {
      asunto: {
        label: 'Asunto de Entregable'
      },

      dia: {
        label: 'Día de Entrega'
      },

      fecha: {
        label: 'Fecha de Entrega',
        desde: {
          placeholder: 'Desde - DD MM, AAAA'
        },

        hasta: {
          placeholder: 'Hasta - DD MM, AAAA'
        }
      },

      mensaje: {
        label: 'Mensaje de Entregable'
      },

      tipo: {
        label: 'Tipo de Entrega'
      }
    }
  }
}

export default mEditionMapActivationSendingOfDeliverablesDropDownFilters
